import {
	createEditDraftPageUrl,
	createEditDraftBlogUrl,
} from '@confluence/content-utils/entry-points/newContentUrl.ts';

export const navigateToNewContent =
	(push) =>
	({ url, data, requestData }) => {
		// NOTE: the editor version is currently available for blank page and blog posts,
		// but not yet available for templates/blueprints. So for templates and blueprints
		// the full page transition.
		const isFabric = requestData?.metadata?.properties?.editor?.value === 'v2';

		const draftUrl =
			requestData.type === 'blogpost' ? createEditDraftBlogUrl(data) : createEditDraftPageUrl(data);

		if (isFabric && draftUrl) {
			push(draftUrl);
		} else {
			// In case of any error or for non-fabric pages just fallback to the default
			// behavior - to the full page redirect navigation.
			window.location = url;
		}
	};
